export default __webpack_public_path__ + "static/media/d7426334798549937ec4b0aeca3d0410.svg";